import classNames from "classnames";
import React from "react";

import styles from "./MobileFilterItem.module.scss";

interface OwnProps {
  onClick?: () => void;
  status?: "active" | "placeholder";
  hasBorder?: boolean;
  className?: string;
}

class MobileFilterItem extends React.PureComponent<OwnProps> {
  public render() {
    const {
      children,
      onClick,
      status = "placeholder",
      hasBorder = false,
      className = "",
    } = this.props;

    return (
      <div
        className={classNames(styles.item, {
          [styles.active]: status === "active",
          [styles.placeholder]: status === "placeholder",
          [styles.hasBorder]: hasBorder === true,
          [className]: className.length,
        })}
        onClick={onClick}
      >
        {children}
      </div>
    );
  }
}

export default MobileFilterItem;
